import Immutable from 'immutable';
import { ONBOARDING_VISIBILITY } from '../actions/onboarding';

const ONBOARDING = 'onboarding';

export default function onboarding(state = Immutable.Map(), action) {
    switch (action.type) {
        case ONBOARDING_VISIBILITY:
            return state.merge(action.payload);
        default:
            return state;
    }
}

export const onboardingVisibilitySelector = (state, id) => state.getIn([ONBOARDING, id], null);
